import script from "./floating_service.vue?vue&type=script&setup=true&lang=js"
export * from "./floating_service.vue?vue&type=script&setup=true&lang=js"

import "./floating_service.vue?vue&type=style&index=0&id=70d380fd&scoped=true&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-70d380fd"]])

export default __exports__